<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >
      <v-card>
        <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn icon @click="close()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text style="padding-top: 20px">
            <v-col cols="12" class="text-center">
                <div id="preview">
                <img
                    :src="url"
                />
                </div>
            </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
    props: {
        dialog: Boolean,
        url: String,
    },
    data() {
        return {
            
        }
    },
    methods: {
        close() {
            this.$emit("closeDialog", false)
        }
    },
}
</script>
<style scoped>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 500px;
}
    
</style>